<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-8 offset-md-2">
        <div class="card py-3">
          <div class="card-body">
            <h2 class="card-title text-center">
              {{ $t("membership360Days") }}
            </h2>

            <p class="text-center text-success mb-5">
              {{ $t("withAffiliate") }}
            </p>

            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <payment-form :product-id="product.id" :product-period="360" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentForm from "../../../components/membership/PaymentForm";

export default {
  name: "360",
  components: { PaymentForm },
  computed: {
    product() {
      return this.$store.getters["membership/getProducts"]["360"];
    },
  },
};
</script>

<style scoped></style>
